import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import Resizer from "react-image-file-resizer";

class   ArticleForm extends Component{

    state = {
        id : null,
        categoryId : null,
        userId : null,
        title : "",
        content : "",
        lastcontent : null,
        status : "actif",
        realization : 0,
        comment : 1,
        image : [],
        images : [],
        dataImage : [],
        categories : [],
        staffs : [],
        loading : false,
        btn  : false
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    async getStaffs(){
        this.setState({
            loading : false
        })

        var society = localStorage.getItem("society") ?  JSON.parse(localStorage.getItem("society")) : {};
        society = society.userprofile ?  society.userprofile.profile ? society.userprofile.profile.society ? society.userprofile.profile.society.id : null : null : null;
      
        var staffs = await axios.get('staffs/' + society);
        if(staffs.status === 200)
        {
            this.setState({staffs : staffs.data, loading : true})
        }
    }

    handleInputFile = (e) => {

        var imgTab = [];

        this.setState({
            image : [],
            dataImage : e.target.files[0],
            btn : false
        })
        for(var i = 0 ; i < e.target.files.length; i++)
        {
            imgTab.push(e.target.files[i]);

            this.setState({
                btn : true,
                dataImage : imgTab
            })
            var img = "";
            try {
            img =  Resizer.imageFileResizer(
                  e.target.files[i],
                  1500,
                  1500,
                  "JPEG",
                  100,
                  0,
                  (uri) => {
                    this.state.image.push(uri);
                    this.setState({ image: this.state.image });
                  },
                  "base64",
                  1000,
                  1000
                );
            } catch (err) {
                console.log(err);
            }
        }
        this.setState({
            btn : false,
            loadingForm : false
        })
    }

    async images(id = null){
        if(id){
            var images = await axios.get("images/" + id);
            if(images.status === 200){
                this.setState({
                    images : images.data
                })
            }
        }
    }


    deleteImage = (id) =>{
        axios.delete("images/" + id).then((response) => {
            this.images(this.state.id);
        }).catch((error)=>{})
    }

    async getCategories () {
      var categories = await axios.get('categories');
        if(categories.status === 200)
        {
            this.setState({ categories : categories.data })
        }
        // var articles = await axios.get('articles/content/' + this.state.id);
        // if(articles.status === 200)
        // {
        //     this.setState({ lastcontent : articles.data.content, loading :true})
        // }
    }

    StoreArticle = async (e) =>{

        this.setState({
            btn : true
        })
        var user = localStorage.getItem("user") ?  JSON.parse(localStorage.getItem("user")) : {};
        var society = localStorage.getItem("society") ?  JSON.parse(localStorage.getItem("society")) : {};
        var societ = society.userprofile ?  society.userprofile.profile ? society.userprofile.profile.society ? society.userprofile.profile.society.id : null : null : null;
        
        let formData = new FormData()

        if(this.state.dataImage && this.state.dataImage.length > 0){
            for(var i = 0 ; i < this.state.dataImage.length; i++)
            {
                formData.append("files", this.state.dataImage[i]);
            }
        }
        if(this.state.categoryId)
            formData.append('categoryId', this.state.categoryId)
        if(this.state.userId)
            formData.append('userId', this.state.userId)
        formData.append('societyId', societ)
        formData.append('title', this.state.title)
        if(this.state.realization >= 0)
            formData.append('realization', this.state.realization)
        formData.append('comment', this.state.comment)
        formData.append('status', this.state.status)
        if(this.state.content && this.state.lastcontent)
            formData.append('content', this.state.lastcontent + this.state.content)

        let header = {
            method: this.state.id ? "PUT": "POST",
            headers : { "x-access-token" : user.refresh_token ? user.refresh_token : "" },
            body: formData 
        }

        let url = this.state.id ? process.env.REACT_APP_API_BEYEGROUP +'/articles/' + this.state.id : process.env.REACT_APP_API_BEYEGROUP +'/articles/';
        
        try{
            const response = await fetch(url, header)
            
            if (response.status === 200)
            {
                this.setState({
                    error : "saved success",
                    btn : false
                })
                this.props.showModal();
            }
            else{
                var error = await response.json();
                this.setState({
                    error : error.msg ? error.msg :  "error when loading",
                    btn : false
                })
            }
        }catch(error) {
            console.log(error)
        }
    }

    edit=()=>  {
        this.form()
        this.getCategories()
        this.getStaffs()
    }

    form=()=>{

        this.setState({
            id: this.props.formData ? this.props.formData.id : null,
            categoryId: this.props.formData ? this.props.formData.category.id : null,
            title: this.props.formData ? this.props.formData.title : "",
            status: this.props.formData ? this.props.formData.status : "actif",
            realization: this.props.formData ? this.props.formData.realization : "0",
            comment: this.props.formData ? this.props.formData.comment : "1",
            userId: this.props.formData ? this.props.formData.user?.id : null,
            // lastcontent: this.props.formData ? this.props.formData.content ? this.props.formData.content : "<p>...</p>" : "<p>...</p>",
            error : "",
        })
        if(this.props.formData && this.props.formData.id)
            this.images(this.props.formData.id);
        else
            this.setState({ images : [] })
    }

    handleCheck(val) {
        var permissions = JSON.parse(localStorage.getItem("permissions"))
          ? JSON.parse(localStorage.getItem("permissions"))
          : [];
        return permissions.some((item) => val === item.name);
      }

    render(){

        return(
            <div>
            <Modal
                show={this.props.isModal}
                onHide={this.props.showModal}
                size="lg"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header>
                    <Modal.Title>{ "Article"}</Modal.Title>
                </Modal.Header>
                <form>
                <Modal.Body className="row">
                    <div className="text-center text-danger text-small small">{ this.state.error }</div>
                    
                    <div className="col-md-6 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Catégorie</label>
                            <div className="position-relative mt-1">
                                <select id="categoryId" name="categoryId" required={true}  value={this.state.categoryId} onChange={this.handleInput} className="form-select">
                                    <option value="">...</option>
                                    {
                                        this.state.categories.map((category) => {
                                            return(
                                                <option value={ category.id} key={category.id}>{ category.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Images</label>
                            <div className="position-relative mt-1">
                                <input type="file" accept="image/*" className="form-control form-control-sm" multiple onChange={this.handleInputFile} />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Titre</label>
                            <div className="position-relative mt-1">
                                <input type="text" className="form-control" placeholder=""  onChange={this.handleInput} name="title"  value={this.state.title} id="nom-id-icon" />
                            </div>
                        </div>
                    </div>
                    

                    {
                        this.handleCheck("admin") == true && (
                        <div className="col-md-12 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Personnel</label>
                                <div className="position-relative mt-1">
                                    <select id="userId" name="userId" required={true}  value={this.state.userId} onChange={this.handleInput} className="form-select">
                                        <option value="">...</option>
                                        {
                                            this.state.staffs.map((staff) => {
                                                return(
                                                    <option value={ staff.id} key={staff.id}>{ staff.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        )
                    }

                    <div className="col-md-4 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Realisation</label>
                            <div className="position-relative mt-1">
                                <select name="realization" onChange={this.handleInput} value={this.state.realization} className="form-control form-control-sm">
                                    <option value={"0"}>Article</option>
                                    <option value={"1"}>Realisation</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Statut</label>
                            <div className="position-relative mt-1">
                                <select name="status" onChange={this.handleInput} value={this.state.status} className="form-control form-control-sm">
                                    <option value={"desactive"}>desactive</option>
                                    <option value={"actif"}>actif</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Visibilité</label>
                            <div className="position-relative mt-1">
                                <select name="comment" onChange={this.handleInput} value={this.state.comment} className="form-control form-control-sm">
                                   <option value={"1"}>normal item</option>
                                    <option value={"-1"}>profile</option>
                                    <option value={"3"}>principal service</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Contenue</label>
                            <div className="position-relative mt-1">
                                <textarea className="form-control" placeholder="" multiple={3}  onChange={this.handleInput} name="content"  value={this.state.content} id="nom-id-icon" ></textarea>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 mt-2">
                    {
                        this.state.images.map((img, index) => {
                            return(<span key={index}>
                                <img src={img.image} alt={ img.image} key={index} className="rounded-3 img-fluid me-1" width={"70"} />
                                <span type="button" onClick={ () => this.deleteImage(img.id)} className="bi bi-x-diamond font-12 text-danger border border-1 border-danger p-1 rounded rounded-circle"></span>
                            </span>
                            )
                        })
                    }
                        {
                            this.state.image.map((img, index) => {
                                return(
                                    <img src={img} alt={img} key={index} className="rounded-3 img-fluid me-1" width={"70"} />
                                )
                            })
                        }
                    </div>

                    <div className="mt-2">
                        <div dangerouslySetInnerHTML={{ __html: this.state.content }} />
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button onClick={this.props.showModal} type="button" className="btn btn-outline-secondary btn-sm"><i className="bi bi-corner-down-left"></i> Fermer</button>
                    <button onClick={ () => this.StoreArticle() } className="btn btn-sm btn-outline-primary" disabled={ this.state.btn }><i className="bi bi-check"></i> Sauvegarder</button>
                </Modal.Footer>
                </form>
            </Modal>


        </div>
        )
    }
}
export default ArticleForm;
